import React, { useState } from "react";
import { NavLink } from "react-router-dom";
import "../../styles/admins/sidebar.css";
import { useNavigate } from "react-router-dom";
import logo from "../../images/logo.png";

function TechieSidebar() {
  const [isCollapsed, setIsCollapsed] = useState(true);
  const navigate = useNavigate();

  const handleMouseEnter = () => {
    setIsCollapsed(false);
  };

  const handleMouseLeave = () => {
    setIsCollapsed(true);
  };

  const handleLogout = () => {
    localStorage.clear();
    navigate("/technician-login");
    window.location.reload();
  };

  return (
    <div
      className={`sidebar ${isCollapsed ? "collapsed" : ""}`}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
    >
      <ul className="sidebar-menu">
        <div className="side-logo-container">
          <img
            src={logo}
style={{
  display: isCollapsed ? "none" : "block",
  height: isCollapsed ? undefined : "2em"
}}
            // className={`${isCollapsed ? "collapsed" : ""}`}
            alt="logo"
          />
        </div>
        <NavLink to="/techie/dashboard">
          <i className="bx bxs-home-smile"></i>
          <li>Dashboard</li>
        </NavLink>
        <br />
        <NavLink to="/techie/profile">
          <i className="bx bxs-user-circle"></i>
          <li>My Profile</li>
        </NavLink>
        <br />
                <NavLink to="/techie/product">
                  <i className="bx bxs-customize"></i>
                  <li>Raise Ticket</li>
                </NavLink>
        <br />
                <NavLink to="/techie/inventory">
          <i className="bx bxs-book-add"></i>
          <li>Inventory</li>
        </NavLink>
        <br />
        <NavLink to="/techie/assets">
          <i className="bx bxs-customize"></i>
          <li> User</li>
        </NavLink>
        <br />
        <NavLink to="/techie/tickets">
          <i className="bx bxs-purchase-tag-alt"></i>
          <li>View Tickets</li>
        </NavLink>
        {/* <br />
        <NavLink to="/techie/send-reports">
          <i className="bx bxs-share"></i>
          <li>Send Reports</li>
        </NavLink> */}
        <br />
        <NavLink to="/techie/view-reports">
          <i className="bx bxs-show"></i>
          <li>View Reports</li>
        </NavLink>
        <br />
        <NavLink to="/techie/logout" onClick={handleLogout}>
          <i className="bx bx-log-out-circle"></i>
          <li>Logout</li>
        </NavLink>
      </ul>
    </div>
  );
}

export default TechieSidebar;
